import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map as rxMap } from 'rxjs/operators';
import { IListViewData } from 'src/ng2/shared/typings/interfaces/list-view.interface';
import { ImStudentActivity } from '../../../im-models/im-student-activity.service';
import { FORMATTED_GROUPING_LISTS } from '../../mad-lib-groupings.constant';

@Injectable()
export class StudentActivitiesGroupings {
  constructor(private imStudentActivity: ImStudentActivity) {
    /* */
  }
  public getStudentActivitiesGrouping(studentActivities$, columns, listType, currentStudentId): Observable<any> {
    return studentActivities$.pipe(
      rxMap(studentActivities => {
        const formattedList: IListViewData = FORMATTED_GROUPING_LISTS.student_activities.getFormattedList({
          columns,
          listType,
        });

        const allStudentActivities = [];
        Object.keys(studentActivities).map(key => {
          const stuActivity = studentActivities[key];
          if (stuActivity.studentId === currentStudentId && stuActivity.status !== 'DELETED')
            allStudentActivities.push(stuActivity);
        });

        return allStudentActivities.reduce((formattedList, studentActivity) => {
          const { _id, completedHours, status, activity } = studentActivity;
          const activityHours = activity.hours ? activity.hours : '-';
          const compHours = completedHours ? completedHours : 0;
          const parsedHours = completedHours ? `${compHours}/${activityHours}` : '-';
          const activityName = this.imStudentActivity.getStudentActivityTitle(studentActivity);
          const parsedStatus = status === 'COMPLETED' ? 'Completed' : 'In progress';
          const dataObj = {
            studentActivityName: {
              data: activityName,
              dependencies: {},
            },
            hours: {
              data: parsedHours,
              dependencies: {},
            },
            status: { data: parsedStatus, dependencies: { studentActivityId: _id } },
          };
          formattedList.sections[0].count++;
          formattedList.sections[0].data.push(dataObj);
          return formattedList;
        }, formattedList);
      }),
    );
  }
}
